<div class="fp-in-container" [formGroup]="fpForm">
    <div class="fp-in-view">
        @if(isOTPRequested) {
        <div class="reset-password">
            <h2 class="fp-in-label">Reset Password</h2>
            <p class="fp-verification-text">OTP sent to **{{requesteEmail}}.</p>
            <p>Please enter new password</p>

            <div class="fp-in-form">
                <ccdl-input
                    [labelName]="'OTP'"
                    controlId="resetOTP"
                    type="otp"
                    [control]="getControl('resetOTP')"
                    [errorConfig]="resetErrorConfig"
                    [displayErrors]="true"
                    autocomplete="one-time-code"></ccdl-input>
                @if(isValidOTP) {
                <ccdl-input
                    [labelName]="'New password'"
                    [showOrHideText]="true"
                    [type]="'password'"
                    controlId="newPassword"
                    [control]="getControl('newPassword')"
                    [displayErrors]="isResetTriggered"
                    [errorConfig]="passwordErrorConfig"
                    autocomplete="new-password"></ccdl-input>
                <ccdl-input
                    [labelName]="'Confirm new password'"
                    [showOrHideText]="true"
                    [type]="'password'"
                    controlId="confirmPassword"
                    [control]="getControl('confirmPassword')"
                    [displayErrors]="isResetTriggered"
                    [errorConfig]="confirmPasswordErrorConfig"
                    autocomplete="new-password"></ccdl-input>
                }
            </div>
            <div class="fp-btn">
                <ccdl-button [btnLabel]="'RESET PASSWORD'"
                    (onClick)="resetPasswordClick()"
                    [btnType]="'primary'"></ccdl-button>
            </div>
        </div>
        } @else {
        <div class="request-otp">
            <h2 class="fp-in-label">Forgot Password</h2>
            <p class="fp-verification-text">Please enter your registered email
                address
                to receive a OTP.
            </p>
            <div class="fp-in-form">
                <ccdl-input
                    [labelName]="'Email address'"
                    controlId="emailId"
                    [control]="getControl('email')"
                    [displayErrors]="isResetTriggered"
                    [errorConfig]="emailErrorConfig"
                    autocomplete="email"></ccdl-input>
            </div>
            <div class="fp-btn">
                <ccdl-button [btnLabel]="'Send OTP'" (onClick)="requestOTP()"
                    [btnType]="'primary'"></ccdl-button>
            </div>
        </div>
        }
    </div>
</div>